module.exports = __webpack_public_path__ + "img/sampleGraph2.c0e4a1c8.png";